import { CopyCodeModule } from './../copy-code/copy-code.module';
import { PipesModule } from './../../pipes/pipes.module';
import { IndianCurrency } from './../../pipes/indian-currency.pipe';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BadgeModule } from "../badge/badge.module";
import { LinkModule } from "../link/link.module";
import { VoucherCardComponent } from "./voucher-card.component";

@NgModule({
    declarations:[VoucherCardComponent],
    imports:[CommonModule,LinkModule,BadgeModule,PipesModule,CopyCodeModule],
    exports:[VoucherCardComponent]
})
export class VoucherCardModule{
    constructor(){

    }
}
